import { tv } from "tailwind-variants"
import { borderVariants } from "../../styles"
import { backgroundVariants } from "../../styles/utils/background"
import { classNames } from "../../utils"

export const arrowButtonContainerVariants = tv({
  base: "pointer-events-none absolute inset-y-0 mx-4",
  variants: {
    variant: {
      default: "",
      overlay:
        "transition-transform duration-300 ease-out-quint group-hover/carousel:translate-x-0",
      static: "relative mx-0",
    },
    disabled: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      variant: ["default", "overlay"],
      disabled: true,
      className: "hidden",
    },
  ],
})

export const arrowButtonBaseVariants = tv({
  base: classNames(
    "pointer-events-auto rounded-full p-2",
    backgroundVariants({ background: "primary" }),
    borderVariants({ border: "border-1" }),
  ),
  variants: {
    variant: {
      default:
        "opacity-0 transition-opacity duration-200 group-hover/carousel:opacity-100",
      overlay:
        "aspect-square size-10 h-auto rounded-full border border-white/20 bg-white/70 opacity-0 backdrop-blur-[30px] transition-opacity duration-200 group-hover/carousel:opacity-100 dark:bg-black/40",
      static: "",
    },
  },
})

export const carouselArrowButtonVariants = tv({
  base: "",
  variants: {
    variant: {
      default: "",
      overlay: "dark",
      static: "",
    },
    direction: {
      previous: "left-0",
      next: "right-0",
    },
  },
  compoundVariants: [
    {
      variant: "overlay",
      direction: "previous",
      className: "ml-6 -translate-x-2.5 justify-start active:scale-95",
    },
    {
      variant: "overlay",
      direction: "next",
      className: "mr-6 translate-x-2.5 justify-end active:scale-95",
    },
  ],
})
